import { TextField } from '@mui/material'
import type { Position } from '../api/generated/Position'

export function PositionSelect({
  positions,
  value,
  onChange,
}: {
  positions: Position[]
  value: string
  onChange: (positionId: string) => void
}) {
  return (
    <TextField
      label="Poste"
      select
      required
      slotProps={{ select: { native: true } }}
      value={value}
      onChange={(e) => onChange((e.target as HTMLSelectElement).value)}
    >
      {positions.map((position) => (
        <option key={position.id} value={position.id}>
          {position.name}
        </option>
      ))}
    </TextField>
  )
}
